import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ded20a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "grid"
}
const _hoisted_2 = {
  key: 1,
  class: "text-center mt-4"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-secondary" }, "Продукты не найдены", -1))
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Product = _resolveComponent("Product")!

  return (_ctx.products.results.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products.results, (product, idx) => {
          return (_openBlock(), _createBlock(_component_Product, {
            key: idx,
            product: product
          }, null, 8, ["product"]))
        }), 128))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
}